import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { servicesQuery } from '@/services/api';
import { useActiveHealthTab } from '../hooks';
import { TotalsPanel } from './totals-panel';
import { WORKSPACE_HEALTH_REFETCH_INTERVAL } from '@/features/workspace-health';

export function AttributesPanel() {
  const workspaceId = getWorkspaceIdFromCurrentUrl() ?? 0;
  const { activeTab } = useActiveHealthTab();

  const totalsQuery = servicesQuery.getAttributesTotals.useQuery({
    queryKey: ['attributes-totals', workspaceId],
    queryData: { params: { environment_id: workspaceId } },
    refetchInterval: WORKSPACE_HEALTH_REFETCH_INTERVAL,
    enabled: workspaceId > 0 && activeTab === 'data',
  });

  return (
    <TotalsPanel
      title="Attributes"
      isLoading={totalsQuery.isLoading}
      totals={totalsQuery.data?.body?.totals}
      viewAllHref={`/workspaces/${workspaceId}/journeys/data-index/attributes`}
      viewAllDestination="attributes"
    />
  );
}
